export function createErrorFieldFromRawError(rawError) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$includeMessage = _ref.includeMessage,
      includeMessage = _ref$includeMessage === void 0 ? false : _ref$includeMessage;

  return {
    stack: rawError.stack,
    kind: rawError.type,
    message: includeMessage ? rawError.message : undefined,
    causes: rawError.causes,
    fingerprint: rawError.fingerprint,
    handling: rawError.handling
  };
}